import React from 'react';
import { FeaturesProvider } from '@nextiva/feature-toggle';
import { useSelector } from 'react-redux';

export const FeatureFlags = ({ children }) => {
  const user = useSelector((state) => state['__global/user'].data ?? null);

  return <FeaturesProvider currentUser={user}>{children}</FeaturesProvider>;
};
